import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/resume-roast/ResumeRoastContent.tsx");
